module.exports = "/assets/d68e2ddc49f6065953daf57eac5b849a.png";